import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Space } from 'antd'

import DeliveryDate from '@/components/B2bDeliveryDate'
import FormatPrice from '@/components/FormatPrice'
import { useAppSelector } from '@/store/hook'
import { selectHideEstimatedDeliveryTime } from '@/store/selectors/configSelector'

interface CartItemNameProps {
  data: {
    name: string
    emptyRow?: boolean
    quantity?: number
    materialNumber?: string | object
    error?: string
    deliveryData?: {
      numberOfItems: number
      deliveryDate: string
    }[]
    checkoutSettings?: {
      includingVAT: boolean
    }
    recyclingFee?: number
    currencyUnit?: string
    replacedByMaterialNumber?: string
    hasMinQuantity?: boolean
  }
  isMobile?: boolean
  shouldShowRecyclingFee?: boolean
}

const CartItemName = ({
  data,
  isMobile = false,
  shouldShowRecyclingFee = false,
}: CartItemNameProps) => {
  const isHideEstimatedDeliveryTime = useAppSelector(selectHideEstimatedDeliveryTime)
  const { t } = useTranslation()

  // old product has the 'replacedByMaterialNumber' property
  // const isOldProduct = !!data?.replacedByMaterialNumber
  // replacement hint only display for the desktop version
  // const shouldDisplayReplacement = !isMobile && isOldProduct

  return (
    <Space className="cart-item-name" direction="vertical">
      <strong className="cart-item-name__title mb-3">
        {data.name}
        {data?.error && (
          <span className="fontBold cart-item-name__error-message">
            {t('errors.nonExistentNumber')}
          </span>
        )}
      </strong>
      {/* {shouldDisplayReplacement && <span>{t('cart.productNotAvailable')}</span>} */}
      {!!data?.error || data.emptyRow || isMobile ? null : (
        !isHideEstimatedDeliveryTime && <DeliveryDate deliveryData={data.deliveryData} />
      )}

      {
        /* data.emptyRow is used to recognize add_quick_entry row which doesn't
        need to render recycling fee price. */
      }
      {shouldShowRecyclingFee && !data?.emptyRow
        ? (
          <span className="cart-item-name__recycling-fee">
            {t('cart.table.additionalCostsPositionLevel')}
            <FormatPrice
              currencyUnit={data?.currencyUnit}
              price={data?.recyclingFee}
            />
          </span>
        )
        : null}
    </Space>
  )
}

export default CartItemName
